<template>
  <div id="xmsq" class="publicMain">
    <el-row class="leftClass align-i-c pb-20">
      <!-- 切换系统 -->
      <el-col :span="xzxtSpan" class="py-5">
        <div class="dy-flex align-i-c">
          <label style="width: 80px;">{{ $t("xmsq.queryFormsqxt") }}：</label>
          <ButtonBox
            :id="'wsbx'"
            :plain="btncolor != 'bx'"
            :buttonData="getArgumentDetail('wsbxbtn')"
            @click.native="getSignatureProject('bx')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
          <ButtonBox
            :id="'wssb'"
            :plain="btncolor != 'sb'"
            :buttonData="getArgumentDetail('wssbbtn')"
            @click.native="getSignatureProject('sb')"
            :uniqueNum="uniqueNum"
            class="ml-10"
          ></ButtonBox>
        </div>
      </el-col>
      <!-- 授权/重置 -->
      <el-col :span="anSpan" class="py-5">
        <el-button size="small" type="primary" @click="sqOperateWc">{{
          $t("xmsq.sqBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("xmsq.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        :key="tableKey"
        border
        stripe
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; font-size: 12px;"
        @select="checkboxEvent"
        @select-all="selectionAll"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
        :max-height="$store.state.screenHeight - 295"
        :row-style="rowStyle"
      >
        <el-table-column
          type="selection"
          width="40"
          key="1"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="bmmc"
          :label="$t('xmsq.bmmc')"
          width="220px"
          align="center"
          header-align="center"
          v-if="tableColumnShow.bmmc"
        >
          <template slot-scope="scope">
            {{ scope.row.bmbh }} / {{ scope.row.bmmc }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmmc"
          :label="$t('xmsq.xmmc')"
          width="500px"
          align="center"
          header-align="center"
          v-if="tableColumnShow.xmmc"
        >
          <template #header>
            <p>
              <span class="mr-5">{{ $t("xmsq.xmmc") }}</span>
              <el-input
                v-model="searchPj"
                size="mini"
                :placeholder="$t('xmsq.searchPlaceholder')"
                style="width: 50%;"
              />
            </p>
          </template>
          <template slot-scope="scope">
            ({{ scope.row.xmbh }}) {{ scope.row.xmmc }} -- {{ scope.row.fzr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="sqqf"
          :label="$t('xmsq.sqqf')"
          align="center"
          header-align="center"
          v-if="tableColumnShow.sqqf"
        >
          <template slot-scope="scope">
            <p>
              <span>{{ $t("xmsq.cyjx") }}</span>
              <span v-if="scope.row.fzrbh == yhxx.ygbh">{{
                "[" + $t("xmsq.xmfzrsqqz") + "]"
              }}</span>
              <span v-if="fzbmbh.includes(scope.row.bmbh)">{{
                "[" + $t("xmsq.bmfzrsqqz") + "]"
              }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="xmsx"
          :label="$t('xmsq.xmsx')"
          align="center"
          width="180px"
          header-align="center"
          v-if="tableColumnShow.xmsx"
          :filters="[
            { text: $t('xmsq.public'), value: '2' },
            { text: $t('xmsq.personal'), value: '1' },
          ]"
          :filter-method="filterHandler"
        >
          <template slot-scope="scope">
            {{
              scope.row.xmsx == "1"
                ? $t("xmsq.personal")
                : scope.row.xmsx == "2"
                ? $t("xmsq.public")
                : ""
            }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 被授权人信息模态框 -->
    <xmsqry-dialog
      :title="$t('xmsq.xzbsqr')"
      :dialogbsqr="dialogbsqr"
      :tableData="ryxxData"
      :uniqueNum="'Y120116-1-2'"
      :cancelBtn="false"
      :confirmBtn="true"
      :searchPlaceholder="$t('xmsq.dghhxmsx')"
      @confirm="confirm"
      @cancel="cancel"
      @searchFilter="searchFilter"
      @handleSelection="handleSelection"
      @selectionAll="selectionAllBsqr"
      v-if="xmsqryFlg"
    >
      <el-row slot="tableHead" class="pb-10">
        <el-select
          v-model="bmvalue"
          filterable
          :placeholder="$t('xmsq.qxzbm')"
          size="small"
          class="pr-10"
          @change="bmSelectChange"
        >
          <el-option
            v-for="item in bmOptions"
            :key="item.bmbh"
            :label="item.bmmc"
            :value="item.bmbh"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row slot="page">
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </xmsqry-dialog>
    <!-- 签批授权弹框 -->
    <el-dialog
      :title="$t('xmsq.qpsq')"
      :visible.sync="signatureDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      append-to-body
      @close="signatureClose"
    >
      <label slot="title">
        <i
          class="el-icon-edit-outline"
          style="font-size: 16px; font-weight: bold;"
        >
          <span style="margin-right: 5px;">
            {{ $t("xmsq.qpsq") }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 5% 0 5%">
        <div>
          <div v-if="isxmfzr == '1'">
            <div class="" style="font-size: 25px;">
              {{ $t("xmsq.xmfzrsqqz") }}
            </div>
            <div class="py-10">
              {{ $t("xmsq.sqqzxm") }}（
              <template v-for="(it, index) in xmfzrsqbh">
                <span :key="index" v-if="index < xmqzsqxsts">{{
                  (index > 0 ? "，" : "") + it
                }}</span>
                <span
                  :key="index"
                  v-if="index == xmqzsqxsts"
                  @click="zkxmqzsq(xmfzrsqbh.length)"
                >
                  ...
                </span>
              </template>
              ）
            </div>
            <el-card>
              <el-form
                :model="xmsqform"
                :label-width="$i18n.locale == 'zh' ? '80px' : '140px'"
              >
                <el-form-item :label="$t('xmsq.queryFormbsqr')">
                  <input-multiple
                    :placeholder="'Please select'"
                    :multiple="true"
                    :collapse-tags="true"
                    :size="'small'"
                    :value="xmsqform.fzrsqry"
                    :collapseTags="false"
                    :filterable="true"
                    @focus="handleFocus()"
                    @clear="clear"
                    :label="'xm'"
                    :value-key="'xm'"
                    clearable
                  ></input-multiple>
                </el-form-item>
                <el-form-item :label="$t('xmsq.queryFormqzrq')">
                  <el-date-picker
                    v-model="xmsqform.time"
                    type="daterange"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('xmsq.to')"
                    :start-placeholder="$t('xmsq.qsrq')"
                    :end-placeholder="$t('xmsq.jzrq')"
                    align="right"
                    size="small"
                    @change="pickerxm"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('xmsq.causeInstructions')">
                  <el-input
                    v-model="xmsqform.sysm"
                    type="textarea"
                    @input="inputsysm"
                  />
                </el-form-item>
              </el-form>
              <p>
                <el-checkbox
                  v-model="tbbmsq"
                  :label="$t('xmsq.tbdbmfzrsq')"
                  size="large"
                  @change="tbbmsqm"
                  :disabled="xmsqform.fzrsqry.length == 0"
                  v-if="isbmfzr == '1'"
                />
              </p>
            </el-card>
          </div>
          <div class="pt-20" v-if="isbmfzr == '1'">
            <div style="font-size: 25px;">
              {{ $t("xmsq.bmfzrsqqz") }}
            </div>
            <div class="py-10">
              {{ $t("xmsq.sqqzxm") }}（<span
                v-for="(it, index) in bmfzrsqbh"
                :key="index"
                >{{ (index > 0 ? "，" : "") + it }}</span
              >
              ）
            </div>
            <el-card>
              <el-form
                :model="bmsqform"
                :label-width="$i18n.locale == 'zh' ? '80px' : '140px'"
              >
                <el-form-item :label="$t('xmsq.queryFormbsqr')">
                  <input-multiple
                    :placeholder="'Please select'"
                    :multiple="true"
                    :collapse-tags="true"
                    :size="'small'"
                    :value="bmsqform.fzrsqry"
                    :collapseTags="false"
                    :filterable="true"
                    @focus="handleFocus2()"
                    @clear="clear2"
                    :label="'xm'"
                    :value-key="'xm'"
                    clearable
                  ></input-multiple>
                </el-form-item>
                <el-form-item :label="$t('xmsq.queryFormqzrq')">
                  <el-date-picker
                    v-model="bmsqform.time"
                    type="daterange"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('xmsq.to')"
                    :start-placeholder="$t('xmsq.qsrq')"
                    :end-placeholder="$t('xmsq.jzrq')"
                    align="right"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('xmsq.causeInstructions')">
                  <el-input v-model="bmsqform.sysm" type="textarea" />
                </el-form-item>
              </el-form>
            </el-card>
          </div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <span class="dialog-footer">
          <el-button @click="signatureClose()" size="small">
            <i class="fa fa-close" />{{ $t("common.cancelBtn") }}
          </el-button>
          <el-button type="primary" @click="signatureConfirm()" size="small">
            <i class="fa fa-check" />{{ $t("common.confirmBtn") }}
          </el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqgl";
import InputMultiple from "@/components/InputMultiple.vue";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";
import dateFormat from "@/utils/dateFormat";

export default {
  // 授权签批
  name: "signatureAuz",
  components: {
    InputMultiple,
    XmsqryDialog,
  },
  computed: {
    xzxtSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 21;
      } else if (1920 >= w && w > 1680) {
        return 21;
      } else if (1680 >= w && w > 1440) {
        return 21;
      } else if (1440 >= w && w > 768) {
        return 19;
      } else if (768 >= w) {
        return 24;
      }
    },
    jeSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 13;
      } else if (1920 >= w && w > 1680) {
        return 13;
      } else if (1680 >= w && w > 1440) {
        return 11;
      } else if (1440 >= w && w > 768) {
        return 6;
      } else if (768 >= w) {
        return 14;
      }
    },
    anSpan() {
      let w = this.$store.state.screenWidth;
      if (w > 1920) {
        return 3;
      } else if (1920 >= w && w > 1680) {
        return 3;
      } else if (1680 >= w && w > 1440) {
        return 3;
      } else if (1440 >= w && w > 768) {
        return 5;
      } else if (768 >= w) {
        return 24;
      }
    },
  },
  watch: {
    value2: {
      handler: function(newVal, oldVal) {
        if (newVal == null) {
          newVal = [];
        }
        this.multipleSelection.forEach((item) => {
          this.tableData[item.index].wcqsrq = newVal[0];
          this.tableData[item.index].wcjzrq = newVal[1];
        });
      },
      deep: true, // 开启深度监听
    },
    iscqyx: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          const end = new Date("2050-12-31");
          const start = new Date();
          // end.setTime(start.getTime() + 3600 * 1000 * 24 * (365 * 30 + 7));
          this.value2 = [
            dateFormat.format(start, "yyyy-MM-dd"),
            dateFormat.format(end, "yyyy-MM-dd"),
          ];
        } else {
          this.value2 = [];
        }
      },
      dreep: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      btncolor: "",
      flg: "0",
      currentRow: null,
      rylbData: [],
      dialogTitle: "人员列表",
      dialogFormVisible: false,
      signatureDialog: false,
      tableKey: 0,
      queryForm: {
        system: "",
        bsqrzjh: "",
        xm: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("xmsq.onemonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.threemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.sixmonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.cqyx"),
            onClick(picker) {
              const end = new Date("2050-12-31");
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      yhbhoryhmc: "",
      multipleSelection: [],
      selectScope: [],
      value2: [],
      iscqyx: false,
      tableData: [],
      tabLoading: false, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      dialogbsqr: false,
      ryxxDataAll: [],
      activeTableData: [],
      ryxxData: [],
      uniqueNum: "Y120116-1-1",
      value: [],
      yhxx: this.$store.state.yhxx.yhxx,
      bmOptions: [],
      bmvalue: "",
      searchData: [],
      search: "",
      xmsqryFlg: true,
      fzbmbh: [],
      isbmfzr: "0",
      xzbsqrlx: "0",
      tbbmsq: false,
      isxmfzr: "0",
      xmsqform: {
        fzrsqry: [],
        time: [],
        sysm: "",
      },
      bmsqform: {
        fzrsqry: [],
        time: [],
        sysm: "",
      },
      xmfzrsqbh: [],
      bmfzrsqbh: [],
      xmqzsqxsts: 10,
      searchPj: "",
      argumentConfig: {
        wsbxbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-bxxt",
        },
        wssbbtn: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-sbxt",
        },
      },
      argumentDetail: {},
      tableColumns: [],
      tableColumnShow: {},
    };
  },
  methods: {
    pickerxm(value) {
      if (this.tbbmsq) {
        this.bmsqform.time = value;
      }
    },
    inputsysm(value) {
      if (this.tbbmsq) {
        this.bmsqform.sysm = value.toString();
      }
    },
    tbbmsqm(value) {
      if (value) {
        Object.assign(this.bmsqform, this.xmsqform);
        // this.bmsqform = this.xmsqform;
      } else {
        this.bmsqform = {
          fzrsqry: [],
          time: [],
          sysm: "",
        };
      }
      // console.log(this.tbbmsq);
    },
    rowStyle(val) {
      let row = val.row;
      if (this.searchPj == "") {
        return;
      } else {
        if (
          row.xmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          row.xmbh.toLowerCase().includes(this.searchPj.toLowerCase())
          // row.bmmc.toLowerCase().includes(this.searchPj.toLowerCase()) ||
          // row.bmbh.toLowerCase().includes(this.searchPj.toLowerCase())
        ) {
          return;
        } else {
          return {
            display: "none",
          };
        }
      }
    },
    // 项目属性筛选方法
    filterHandler(value, row, column) {
      // console.log(row);
      const property = column["property"];
      return row[property] === value;
    },
    // 根据部门编号查询被授权人
    getSysUserByBmbh(bmbh) {
      yhxx.getSysUserByBmbh({ bmbh: bmbh }).then((res) => {
        this.ryxxDataAll = res.data.data;
        this.activeTableData = this.ryxxDataAll;
        this.dataPaging(this.ryxxDataAll);
      });
    },
    // 被授权人数据分页
    dataPaging(activeTableData) {
      this.ryxxData = [];
      if (activeTableData) {
        this.total = activeTableData.length;
        if (activeTableData.length <= (this.currentPage - 1) * this.limit) {
          this.currentPage = 1;
        }
        let i = (this.currentPage - 1) * this.limit;
        for (
          i;
          i < this.currentPage * this.limit && i < activeTableData.length;
          i++
        ) {
          this.ryxxData.push(activeTableData[i]);
        }
      }
    },
    // 获取部门信息
    getBmxxList() {
      this.bmvalue = this.yhxx.gzbmbh;
      if (this.bmvalue != null && this.bmvalue != "") {
        this.getSysUserByBmbh(this.bmvalue);
      }

      yhxx.getBmxxList().then((res) => {
        this.bmOptions = res.data.data;
      });
    },
    // 部门变化方法
    bmSelectChange(bmbh) {
      this.getSysUserByBmbh(bmbh);
    },
    // 筛选方法
    searchFilter(search) {
      this.search = search;
      if (search) {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        let data = [];
        this.activeTableData.filter((item) => {
          if (
            item.xm.toLowerCase().includes(search.toLowerCase()) ||
            item.rydm.toLowerCase().includes(search.toLowerCase())
          ) {
            data.push(item);
          }
        });
        this.searchData = this.activeTableData;
        this.activeTableData = data;
        this.dataPaging(data);
      } else {
        if (this.searchData.length > 0) {
          this.activeTableData = this.searchData;
        }
        this.dataPaging(this.activeTableData);
        this.searchData = [];
      }
    },
    // 表格选中状态改变时方法
    handleSelection(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      if (this.xzbsqrlx == "0") {
        this.xmsqform.fzrsqry = selection;
        if (this.tbbmsq) {
          this.bmsqform.fzrsqry = selection;
        }
      } else if (this.xzbsqrlx == "1") {
        this.bmsqform.fzrsqry = selection;
      }
    },
    // 表格点击全选时方法
    selectionAllBsqr(selection) {
      selection.forEach((item, index) => {
        if (item.rydm === this.yhxx.ygbh) {
          this.$message.error("无需对自己授权(" + item.rydm + ")");
          selection.splice(index, 1);
        }
      });
      if (this.xzbsqrlx == "0") {
        this.xmsqform.fzrsqry = selection;
        if (this.tbbmsq) {
          this.bmsqform.fzrsqry = selection;
        }
      } else if (this.xzbsqrlx == "1") {
        this.bmsqform.fzrsqry = selection;
      }
    },

    handleCurrentChange(val) {
      this.currentRow = val;
    },
    // 表格点击全选时方法
    selectionAll(selection) {
      this.multipleSelection = [];
      this.selectScope = selection;
      if (this.value2.length > 0) {
        selection.forEach((item) => {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
          if (this.kzje != "") {
            item.kzsqje = this.kzje;
          }
        });
      }
      this.multipleSelection = selection;
    },

    // 选择表格方法
    checkboxEvent(scope, row) {
      this.selectScope = scope;
      row.qssj = "";
      row.jzsj = "";
      let v = this.value2.length > 0;
      scope.forEach((item) => {
        if (v) {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
        }
      });
    },
    // 选择状态改变时方法
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 网查授权项目
    getSignatureProject(system) {
      let _this = this;

      if (system == "bx") {
        _this.btncolor = system;
      } else if (system == "sb") {
        _this.btncolor = system;
      }
      _this.queryForm.system = system;
      _this.queryForm.isbmfzr = _this.fzbmbh.length > 0 ? "1" : "0";
      _this.tableData = [];
      _this.tabLoading = true; // 关闭请求时的loading层
      sqgl
        .getSignatureProject(_this.queryForm)
        .then((res) => {
          _this.tabLoading = false; // 关闭请求时的loading层
          if (res.data.code == "200") {
            res.data.data.forEach((item, index) => {
              item.wcqsrq = "";
              item.wcjzrq = "";
              item.index = index;
            });
            _this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
        });
    },

    // 获取被授权人
    getUserinfo() {
      let _this = this;
      if (_this.yhbhoryhmc == "") {
        // this.$refs.yhbhoryhmc2.innerHTML = "";
      } else {
        sqgl
          .getUserinfo(_this.$qs.stringify({ yhbhoryhmc: _this.yhbhoryhmc }))
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.data.ryxx.length == 0) {
                // this.$refs.yhbhoryhmc2.innerHTML = "";
                _this.$message.error(_this.$t("xmsq.zbdryxx"));
              }
            }
          });
      }
    },

    querenBtn() {
      if (this.flg == "1") {
        this.yhbhoryhmc = this.currentRow.RYDM;
      } else if (this.flg == "2") {
        this.yhbhoryhmc = this.currentRow.XM;
      }
      this.dialogFormVisible = false;
    },
    zkxmqzsq(size) {
      this.xmqzsqxsts = size;
    },
    // 确认授权操作
    sqOperateWc() {
      let _this = this;
      _this.xmqzsqxsts = 10;
      _this.xmfzrsqbh = [];
      _this.bmfzrsqbh = [];
      _this.isxmfzr = "0";
      _this.isbmfzr = "0";
      if (_this.multipleSelection.length == 0) {
        _this.$message.error(_this.$t("xmsq.qxzsqxm"));
        return false;
      }
      _this.xmsqform.time = _this.value2;
      _this.bmsqform.time = _this.value2;
      _this.multipleSelection.forEach((item) => {
        if (item.fzrbh == _this.yhxx.ygbh) {
          _this.isxmfzr = "1";
          _this.xmfzrsqbh.push(item.xmbh);
        }
        if (_this.fzbmbh.includes(item.bmbh)) {
          _this.isbmfzr = "1";
          _this.bmfzrsqbh.push(item.xmbh);
        }
      });
      _this.signatureDialog = true;
    },

    /** 重置操作 */
    resetSearch(typeFlg) {
      this.yhbhoryhmc = "";
      this.clear();
      this.btncolor = "";
      this.tableData = [];
      this.iscqyx = false;
    },
    // 被授权人框获得焦点方法
    handleFocus(event) {
      this.dialogbsqr = true;
      this.xzbsqrlx = "0";
    },
    handleFocus2(event) {
      this.dialogbsqr = true;
      this.xzbsqrlx = "1";
    },
    // 选择人员确认
    confirm(ryxx) {
      if (this.xzbsqrlx == "0") {
        this.xmsqform.fzrsqry = ryxx;
        if (this.tbbmsq) {
          this.bmsqform.fzrsqry = ryxx;
        }
      } else if (this.xzbsqrlx == "1") {
        this.bmsqform.fzrsqry = ryxx;
      }
      this.dialogbsqr = false;
    },
    // 取消选择人员
    cancel() {
      this.xmsqryFlg = false;
      this.dialogbsqr = false;
      this.activeTableData = this.ryxxDataAll;
      this.dataPaging(this.ryxxDataAll);
      this.$nextTick(() => {
        this.xmsqryFlg = true;
      });
    },
    // 确认授权签字
    signatureConfirm() {
      let data = [];
      let ok = true;
      if (
        this.xmsqform.fzrsqry.length == 0 &&
        this.bmsqform.fzrsqry.length == 0
      ) {
        ok = false;
        this.$message.error("未选择被授权人");
      } else if (
        this.xmsqform.time.length < 2 &&
        this.bmsqform.time.length < 2
      ) {
        ok = false;
        this.$message.error("未选择授权起止时间");
      } else if (
        this.xmsqform.fzrsqry.length > 0 &&
        this.xmsqform.time.length == 2 &&
        this.xmsqform.sysm == ""
      ) {
        ok = false;
        this.$message.error("项目负责人授权事由说明不能为空");
      } else if (
        this.bmsqform.fzrsqry.length > 0 &&
        this.bmsqform.time.length == 2 &&
        this.bmsqform.sysm == ""
      ) {
        ok = false;
        this.$message.error("部门负责人授权事由说明不能为空");
      }
      if (ok) {
        this.multipleSelection.forEach((item) => {
          if (
            item.fzrbh == this.yhxx.ygbh &&
            this.xmsqform.fzrsqry.length > 0 &&
            this.xmsqform.time.length == 2
          ) {
            let it = {};
            it.bmbh = item.bmbh;
            it.bmmc = item.bmmc;
            it.xmbh = item.xmbh;
            it.sqrzjh = this.yhxx.ygbh;
            it.bsqrzjh = this.xmsqform.fzrsqry[0].rydm;
            it.sysid = this.btncolor;
            it.systemType = this.btncolor;
            it.sqqsrq = this.xmsqform.time[0];
            it.sqjzrq = this.xmsqform.time[1];
            it.sy = "代签字授权(项目)";
            it.xmmc = item.xmmc;
            it.sqreason = this.xmsqform.sysm;
            it.sqqf = "xmfzr";
            data.push(it);
          }
          if (
            this.fzbmbh.includes(item.bmbh) &&
            this.bmsqform.fzrsqry.length > 0 &&
            this.bmsqform.time.length == 2
          ) {
            let it = {};
            it.bmbh = item.bmbh;
            it.bmmc = item.bmmc;
            it.xmbh = item.xmbh;
            it.sqrzjh = this.yhxx.ygbh;
            it.bsqrzjh = this.bmsqform.fzrsqry[0].rydm;
            it.sysid = this.btncolor;
            it.systemType = this.btncolor;
            it.sqqsrq = this.bmsqform.time[0];
            it.sqjzrq = this.bmsqform.time[1];
            it.sy = "代签字授权(部门)";
            it.xmmc = item.xmmc;
            it.sqreason = this.bmsqform.sysm;
            it.sqqf = "bmfzr";
            data.push(it);
          }
        });
        sqgl.signAuthorization(data).then((res) => {
          this.signatureDialog = false;
          if (res.data.code == "200") {
            this.$message.success(res.data.data);
            this.bmsqform = {
              fzrsqry: [],
              time: [],
              sysm: "",
            };
            this.xmsqform = {
              fzrsqry: [],
              time: [],
              sysm: "",
            };
          }
        });
      }
    },
    // 取消授权签字
    signatureClose() {
      this.signatureDialog = false;
      this.bmsqform = {
        fzrsqry: [],
        time: [],
        sysm: "",
      };
      this.xmsqform = {
        fzrsqry: [],
        time: [],
        sysm: "",
      };
    },
    // 清空选择框
    clear() {
      this.xmsqryFlg = false;
      this.xmsqform.fzrsqry = [];
      if (this.tbbmsq) {
        this.bmsqform.fzrsqry = [];
      }
      this.$nextTick(() => {
        this.xmsqryFlg = true;
      });
    },
    // 清空选择框
    clear2() {
      this.xmsqryFlg = false;
      this.bmsqform.fzrsqry = [];
      this.$nextTick(() => {
        this.xmsqryFlg = true;
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.dataPaging(this.activeTableData);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.dataPaging(this.activeTableData);
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120116",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      this.tabLoading = true;
      let params = {};
      params.pageId = "Y120116";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil
        .getXtTableConfig(params)
        .then((tmpResult) => {
          this.tableColumns = tmpResult;
          let shows = {};
          this.tableColumns.forEach((item) => {
            if (item.columnKey != "xzk") {
              shows[item.columnKey] = item.isShow == "1" ? true : false;
            }
          });
          this.tableColumnShow = shows;
          this.tabLoading = false;
        })
        .catch((err) => {
          this.tabLoading = false;
        });
    },
  },
  mounted() {
    this.getBmxxList();
    this.getPageTableConfig();
    this.loadQueryConfig();
    sqgl.getIsBmfzr().then((res) => {
      let data = [];
      data = res.data.data;
      data.forEach((it) => {
        this.fzbmbh.push(it.toString());
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}
.rightClass {
  margin: 10px 0;
}

/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 50px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}

::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 70px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
